import { useCallback } from 'react';
import { pick, prop } from 'ramda';

import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as server from '../server';

export const useGetTemporaryAuthenticationToken = () => {
    const { userName, sessionToken } = useUserSelector(pick(['userName', 'sessionToken']));
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (serviceType = 'GamePlay') => {
        const response = await server.getTemporaryAuthenticationToken({
            userName, casinoName, serviceType, sessionToken
        });

        return response?.data?.token;
    }, [userName, sessionToken, casinoName]);
};
